import { Reveal } from "@frontend/components/site/reveal";
import { Section } from "@frontend/components/site/section";

const STEPS = [
  {
    title: "Claim your link",
    body: "Pick a username and your page is live. Put it in your bio — anyone can send an offer, and only you can change what it says.",
  },
  {
    title: "They send an offer",
    body: "Amount, delivery window, payment plan and brief — in a form, not a paragraph. Free to send; they can boost to the top of your inbox.",
  },
  {
    title: "Counter until it fits",
    body: "Each counter is a new version with a diff. Accepting freezes the winning terms into a contract both of you can open.",
  },
  {
    title: "Get paid by stage",
    body: "Tranches fall due as you hit milestones. They pay your UPI or bank directly and log it; you confirm what landed.",
  },
];

export function HowItWorks({ host: _host }: { host: string }) {
  return (
    <Section id="how-it-works" className="bg-white">
      <Reveal>
        <p className="mkt-kicker">How it works</p>
        <h2 className="mkt-display mt-4 max-w-3xl text-4xl leading-[1.05] text-balance sm:text-5xl lg:text-[3.5rem]">
          From a link in your bio to <span className="mkt-serif text-[#0a9f56]">money in the bank</span>
        </h2>
      </Reveal>

      <ol className="mt-12 border-t border-ink/10">
        {STEPS.map((step, index) => (
          <Reveal
            key={step.title}
            as="li"
            delay={index * 70}
            className="border-b border-ink/10 last:border-b-0"
          >
            <div className="mkt-step group grid grid-cols-[2.75rem_minmax(0,1fr)] gap-x-4 gap-y-2 py-7 sm:grid-cols-[4.5rem_minmax(0,15rem)_minmax(0,1fr)] sm:items-start sm:gap-x-8 sm:gap-y-0 lg:py-9">
              <span className="mkt-display tabular text-xl leading-[1.35] text-ink/25 transition-colors duration-300 group-hover:text-[#0a9f56] sm:text-2xl sm:leading-[1.3]">
                0{index + 1}
              </span>
              <h3 className="mkt-display text-xl leading-[1.35] text-ink sm:text-2xl sm:leading-[1.3]">
                {step.title}
              </h3>
              <p className="col-start-2 text-[15px] leading-relaxed text-ink/55 sm:col-start-3 sm:text-base">
                {step.body}
              </p>
            </div>
          </Reveal>
        ))}
      </ol>
    </Section>
  );
}
